// Resolve the base URL for backend API calls.
//
// There are three deploy topologies in play:
//
// 1. **Netlify-fronted** (ask.agami.ai, app.agami.ai, askstage,
//    agamistage): the SPA is served by Netlify, the API is on a
//    different origin (Cloud Run). Netlify proxies /api/* to the
//    backend, but the edge has a ~26-second timeout that 504s long
//    SSE streams (SunMobility Azure-tunneled queries take 20-60s).
//    Hit Cloud Run directly here — CORS is allowlisted.
//
// 2. **Same-origin Cloud Run** (mcp.agami.ai, mcpstage.agami.ai,
//    demo.agami.ai, public.agami.ai): the same Cloud Run image
//    serves both API and SPA. Bare path works — no /api prefix,
//    no cross-origin.
//
// 3. **Localhost dev**: Vite serves the SPA on :5173 and proxies
//    /api/* to the backend on :8000. Use the /api prefix so the
//    proxy rewrite kicks in.
export function api(path: string): string {
  if (typeof window === "undefined") return path;
  const host = window.location.hostname;
  // (1) Netlify bypass — call Cloud Run directly.
  if (host === "ask.agami.ai" || host === "app.agami.ai") {
    return `https://data-agent-app-prod-ovemxbxn4q-el.a.run.app${path}`;
  }
  if (host === "askstage.agami.ai" || host === "agamistage.netlify.app") {
    return `https://data-agent-app-staging-ovemxbxn4q-el.a.run.app${path}`;
  }
  // (2) Same-origin Cloud Run — bare path resolves to the same image.
  if (
    host === "mcp.agami.ai" ||
    host === "mcpstage.agami.ai" ||
    host === "demo.agami.ai" ||
    host === "public.agami.ai" ||
    host === "publicstage.agami.ai"
  ) {
    return path;
  }
  // (3) Localhost via Vite proxy; fallback for any other hostname
  //     keeps the /api prefix so Netlify _redirects can route it.
  return `/api${path}`;
}
